import React, { PureComponent } from 'react';
import { Route, RouteComponentProps, withRouter } from 'react-router-dom';
import { BaseProps } from '../components/page-view/types';
import { fomatParentPath } from '../utils';

const PageError = React.lazy(
  () => import(
    /* webpackChunkName: "page_exception" */
    '../components/page-error'
  ),
);

export interface RoutePageErrorProps extends React.Attributes, BaseProps {
  path?: string;
}

class RoutePageError extends PureComponent<RoutePageErrorProps & RouteComponentProps> {
  render() {
    const { path } = this.props;

    const parentPath = fomatParentPath(this.props);

    return (
      <Route
        weId={`${this.props.weId || ''}_b7df88`}
        path={path || `${parentPath}/pageerror`}
        component={PageError}
        exact
      />
    );
  }
}

export default withRouter(RoutePageError);
